import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class XmlService {

    constructor(private readonly http: HttpClient) { }

    processarZip(arquivoZip: File) {
      const formData = new FormData();
      formData.append('files', arquivoZip);

      return this.http.post(`${environment.apiUrl}${environment.versionApi}/xml/classifica-entradas-cte`, formData, {
        responseType: 'blob' // Espera um arquivo ZIP como resposta
      });
    }

}
